import React from "react";
import SingleParkingRate from "./singleParkingRate/singleParkingRate";
import {observer} from "mobx-react";
import {IPriceStore} from "../../../stores/priceStore";
import i18n from "../../../../i18n/i18n";
import {Popup} from "../../../../common/components/shared/popup/popup";
import {ReactComponent as RemoveIcon} from "../../../../statics/icons/icon_remove.svg";
import Row from "../../../../common/components/shared/row/row";
import TextInput from "../../../../common/components/shared/textInput/textInput";
import {ValidatedValue} from "../../../../helpers/validatedValue";
import {IconButton} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface ParkingRatesSectionProps extends RouteComponentProps {
    priceIndex: number;
    store: IPriceStore;
}

interface ParkingRatesSectionState {
    selectedElement: number | undefined;
    displayRemovePopup: boolean;
}

class ParkingRatesSection extends React.Component <ParkingRatesSectionProps, ParkingRatesSectionState> {
    constructor(props: any) {
        super(props);

        this.state = {
            selectedElement: undefined,
            displayRemovePopup: false
        };
    }

    get store() {
        return this.props.store;
    }

    get selectedPriceList() {
        return this.store.priceList[this.props.priceIndex];
    }

    render() {
        return (
            <div className="parking-rates-section section with-border">
                {this.selectedPriceList.parkingRates.length >= 1 && this.selectedPriceList.parkingRates.map((element, parkingRateIndex) =>
                    <SingleParkingRate
                        key={`single-parking-rate-${parkingRateIndex}`}
                        priceIndex={this.props.priceIndex}
                        parkingRateIndex={parkingRateIndex}
                        onRemoveAction={() => this.setState({
                            selectedElement: parkingRateIndex,
                            displayRemovePopup: true
                        })}
                        onAddAction={() => {
                            this.selectedPriceList.createParkingRate();
                        }}
                    />
                )}
                <Row class="single-parking-rate flex-type gap-30">
                    <TextInput
                        label={i18n.t("priceList.headers.parkingTime")}
                        validatedValue={new ValidatedValue(">")}
                        testId={`parking-time-for-other-${this.props.priceIndex}`}
                        disabled
                        offAutocomplete
                    />
                    <TextInput
                        label={i18n.t("priceList.headers.parkingFee")}
                        validatedValue={this.selectedPriceList.parkingFeeForOther}
                        testId={`parking-fee-for-other-${this.props.priceIndex}`}
                        onChange={() => {
                            const isOneFreeTime = {
                                name: "isOneFreeTime",
                                fn: (value: number) => {
                                    let freeTime = false;

                                    this.props.store.priceList[this.props.priceIndex].parkingRates.forEach((parkingRates) => {
                                        if (parkingRates.parkingFee.value && parkingRates.parkingFee.value.toString() === "0") {
                                            freeTime = true;
                                        }
                                    });

                                    if (freeTime) {
                                        return (freeTime && value > 0);
                                    }
                                    return true;
                                },
                                errorMessage: () => i18n.t("priceList.errors.isOneFreeTime")
                            };

                            this.selectedPriceList.parkingFeeForOther.addValidators([isOneFreeTime]);
                        }}
                        offAutocomplete
                        type="number"
                        placeholderNumberType={i18n.t("priceFormat")}
                    />
                    {this.selectedPriceList.parkingRates.length === 0 && (
                        <IconButton
                            className="add-parking-rate-btn"
                            onClick={() => {
                                this.selectedPriceList.createParkingRate();
                            }}
                            data-testid="add-parking-rate-when-list-is-empty-btn"
                        >
                            <AddIcon fontSize="large"/>
                        </IconButton>
                    )}
                </Row>
                {this.renderRemovePopup(this.confirmRemove.bind(this))}
            </div>
        );
    }

    protected renderRemovePopup(confirmRemove: any) {
        const value = i18n.t("priceList.removePriceList.parkingRate");
        const header = `${i18n.t("priceList.removePriceList.header", {value: value})}`;
        const secondHeader = `${i18n.t("priceList.removePriceList.secondHeader", {value: value})}`;
        const content = <div>
            <p>{i18n.t("priceList.removePriceList.line1", {value: value})}</p>
            <p>{i18n.t("priceList.removePriceList.line2")}</p>
        </div>;

        return (
            <Popup
                open={this.state.displayRemovePopup}
                className="remove-popup popup-with-secondary-button-color"
                header={header}
                secondHeader={secondHeader}
                icon={<RemoveIcon/>}
                content={content}
                actionText={i18n.t("priceList.removePriceList.actionText")}
                action={confirmRemove}
                cancel={() => this.setState({displayRemovePopup: false})}
                testId="remove-popup"
            />
        );
    }

    private confirmRemove() {
        if (this.state.selectedElement !== undefined) {
            this.selectedPriceList.removeParkingRate(this.state.selectedElement);

            this.setState({selectedElement: undefined, displayRemovePopup: false});
        }
    }
}

export default withRouter(observer(ParkingRatesSection));